export enum EnquiryTypes {
  CAMPAIGN_SETUP = "Campaign Setup",
  ACCOUNT_ISSUES = "Account Issues",
  OTHER = "Other",
  PARTNERSHIPS = "Partnerships",
  REPORT_A_CAMPAIGN = "Report a Campaign",
  GIVING = "Giving",
}
